import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function CTASticky() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 800);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const abrirWidget = () => {
    const btn = document.querySelector('#vapi-widget-floating-button') as HTMLElement | null;
    if (btn) btn.click();
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-[#0d0d0d] border-t border-gold-500/20">
      <div className="max-w-7xl mx-auto px-6 py-3">
        <div className="flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-center md:text-left">
            <p className="text-white font-semibold text-sm font-['Montserrat']">
              Pronto para transformar sua vida?
            </p>
            <p className="text-white/40 text-xs font-['Montserrat']">
              Comece sua jornada de autoconhecimento hoje mesmo
            </p>
          </div>
          <div className="flex gap-2.5">
            <button
              onClick={abrirWidget}
              className="flex items-center gap-2 px-4 py-2 bg-white/6 hover:bg-white/12 text-white/70 hover:text-white font-medium rounded-full transition-all whitespace-nowrap text-sm border border-white/10 hover:border-white/25 cursor-pointer font-['Montserrat']"
            >
              <i className="ri-customer-service-2-line text-gold-400 text-base" />
              Falar com a Bia
            </button>
            <Link
              to="/quiz"
              className="px-4 py-2 bg-white/8 border border-white/15 text-white/80 hover:text-white font-medium rounded-full hover:bg-white/14 transition-all whitespace-nowrap text-sm font-['Montserrat']"
            >
              Fazer Quiz Gratuito
            </Link>
            <Link
              to="/planos"
              className="px-5 py-2 bg-gradient-to-r from-gold-500 to-gold-700 text-[#0a0a0a] font-bold rounded-full hover:from-gold-400 hover:to-gold-600 transition-all whitespace-nowrap text-sm font-['Montserrat']"
            >
              Ver Planos
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
